import React from "react";
import PropTypes from "prop-types";

const HANDLES = [
  "top-left",
  "top",
  "top-right",
  "right",
  "bottom-right",
  "bottom",
  "bottom-left",
  "left",
];

export default function StudioResizeHandles({
  visible = false,
  onPointerDown = null,
}) {
  if (!visible) {
    return null;
  }

  return (
    <span
      className="studio-framework-resize-handles"
      aria-hidden="true"
    >
      {HANDLES.map((handle) => (
        <span
          key={handle}
          className={[
            "studio-framework-resize-handle",
            `studio-framework-resize-handle--${handle}`,
          ].join(" ")}
          data-resize-handle={handle}
          onPointerDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onPointerDown?.(event, handle);
          }}
        />
      ))}
    </span>
  );
}

StudioResizeHandles.propTypes = {
  visible: PropTypes.bool,
  onPointerDown: PropTypes.func,
};
